import React, { useState } from "react";
import Navbar from '../Components/Navbar'
import img from '../Assets/contact.jpeg'
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
const faqData = [
  {
    question: "What is IVF and how does it work?",
    answer:
      "In Vitro Fertilization (IVF) is an advanced fertility treatment where eggs are fertilized with sperm outside the body in a laboratory. The resulting healthy embryo is then transferred into the uterus to achieve pregnancy.",
  },
  {
    question: "When should we consider consulting a fertility specialist?",
    answer:
      "Couples who have been trying to conceive for over a year (or six months if the woman is above 35 years) should consider consulting a fertility specialist for proper evaluation and guidance.",
  },
  {
    question: "Is IVF treatment painful?",
    answer:
      "Most IVF procedures are minimally invasive and performed under expert supervision. Mild discomfort may occur during certain steps, but the treatment is generally well-managed and safe.",
  },
  {
    question: "What is the success rate of IVF?",
    answer:
      "IVF success rates depend on various factors such as age, medical history, and underlying fertility conditions. During consultation, a personalized assessment is done to provide realistic expectations.",
  },
  {
    question: "How long does the IVF process take?",
    answer:
      "A typical IVF cycle usually takes about 4–6 weeks from initial evaluation to embryo transfer, depending on the individual treatment plan.",
  },
  {
    question: "Do you offer personalized fertility treatment plans?",
    answer:
      "Yes, every patient receives a customized treatment plan based on their medical condition, diagnostic results, and fertility goals to ensure the best possible outcomes.",
  },
];


const hospitalSchedule = {
  "Aadhya 9 Hospital, Shadipur": {
    days: ["Monday","Wednesday","Thursday","Saturday","Sunday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Apollo Cradle, Moti Nagar": {
    days: ["Tuesday","Friday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Kailash IVF, Noida": {
    days: ["Monday","Tuesday","Wednesday","Friday","Saturday","Sunday"],
    time: "9:00 AM - 1:00 PM"
  }
};


function Contact() {

  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  const [name,setName] = useState("");
const [phone,setPhone] = useState("");
const [email,setEmail] = useState("");
const [hospital,setHospital] = useState("");
const [date,setDate] = useState("");
const [time,setTime] = useState("");

const handleDate = (value)=>{

const selectedDate = new Date(value);
const day = selectedDate.toLocaleString("en-US",{weekday:"long"});

if(hospitalSchedule[hospital]?.days.includes(day)){
setDate(value)
setTime(hospitalSchedule[hospital].time)
}
else{
alert("Doctor not available on this day")
setDate("")
setTime("")
}

}

const sendWhatsapp = async () => {

  if(!name || !phone || !email || !hospital || !date){
    alert("Please fill all required fields including email");
    return;
  }

  const templateParams = {
    name,
    phone,
    email,
    hospital,
    date,
    time
  };

  const message = `Appointment Booking

Name: ${name}
Phone: ${phone}
Hospital: ${hospital}
Date: ${date}
Time: ${time}
Email: ${email}
`;

  const whatsappUrl = `https://wa.me/917703895964?text=${encodeURIComponent(message)}`;

  try {

    await emailjs.send(
      "service_n802jco",
      "template_g6paq09",
      templateParams,
      "yClAt8VCazgj2VJJ7"
    );

    console.log("Admin mail sent");

    await emailjs.send(
      "service_n802jco",
      "template_2i7nheg",
      templateParams,
      "yClAt8VCazgj2VJJ7"
    );

    console.log("User mail sent");

    alert("Appointment booked successfully!");

    // IMPORTANT CHANGE
    window.location.href = whatsappUrl;

    setName("");
    setPhone("");
    setEmail("");
    setHospital("");
    setDate("");
    setTime("");

  } catch (err) {
    console.log("ERROR:", err);
    alert("Something went wrong! Check console.");
  }

};


  return (
    <>
    <Helmet>
  <title>Book IVF Appointment in Delhi | Dr. Monika Gupta Fertility Clinic</title>

  <meta
    name="description"
    content="Book an appointment with Dr. Monika Gupta, IVF specialist in Delhi with 15+ years experience. Visit fertility clinic or call now for consultation."
  />

  <meta
    name="keywords"
    content="IVF appointment Delhi, fertility clinic near me, book IVF consultation Delhi, IVF doctor contact Delhi, gynecologist appointment Delhi, infertility clinic Delhi"
  />

  <meta property="og:title" content="Book IVF Appointment | Dr. Monika Gupta" />
  <meta property="og:description" content="Schedule your fertility consultation with an expert IVF specialist in Delhi." />
  <meta property="og:type" content="website" />

  <meta name="robots" content="index, follow" />
</Helmet>
    <Navbar/>
      <div className='banner-page'>
        <h3>Contact Us</h3>

        <p>Home-Contact Us</p>

        </div>

        <div className='contact-div'>
            <h2>Connect With Dr. Monika Gupta </h2>

            <div className='contact-info'>

            <div className='contact-div-left'>
  
  <div className='map-div'>
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30773461.225284647!2d61.025476562853726!3d19.690216512589846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1771655987679!5m2!1sen!2sin">
    </iframe>

    {/* <div className='office-info'>
      <div className='info-icon'>
        <i className="bi bi-geo-alt-fill"></i>
      </div>
      <div className='info-text'>
        <h3>Clinic Locations</h3>
        <p>
          Kailash IVF, Noida<br/>
          Apollo Cradle, Moti Nagar<br/>
          Aadhya 9 Hospital, Shadipur, Delhi
        </p>
      </div>
    </div> */}
  </div>

  <div className='office-info'>
    <div className='info-icon'>
      <i className="bi bi-telephone-fill"></i>
    </div>
    <div className='info-text'>
      <h3>Phone</h3>
      <p>+91 7703895964</p>
    </div>
  </div>

  <div className='office-info'>
    <div>

    <div className='info-icon'>
      <i className="bi bi-envelope-fill"></i>
    </div>
    </div>
    <div className='info-text'>
      <h3>Email</h3>
      <p>drmonicaivf@gmail.com</p>
    </div>
  </div>

  <div className='office-info'>
    <div>

    <div className='info-icon'>
      <i className="bi bi-alarm-fill"></i>
    </div>
    </div>
    <div className='info-text'>
      <h3>OPD Timings</h3>
      <p>
        <strong> Aadhya 9 Hospital, Shadipur:</strong> Mon, Wed, Thu, Sat, Sun – 5:00 PM – 7:00 PM<br/>
        <strong>Apollo Cradle, Moti Nagar:</strong> Tue, Fri – 5:00 PM – 7:00 PM<br/>
        <strong>Kailash IVF, Noida:</strong> 9:00 AM – 1:00 PM (Thursday Closed)<br/>
      </p>
    </div>
  </div>

</div>
            <div className='contact-div-right'>

<div className="client-timing-left-form">

<h4>Make an appointment</h4>
<br/>

<div className="ips">
<div className="ip">
<label>Full Name</label>
<input type="text" value={name} onChange={(e)=>setName(e.target.value)}/>
</div>

<div className="ip">
<label>Phone</label>
<input type="text" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
</div>
</div>


<div className="ips">

<div className="ip">
<label>Email</label>
<input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
</div>

<div className="ip">

<label>Select Hospital</label>

<select value={hospital} onChange={(e)=>setHospital(e.target.value)}>

<option value="">Select Hospital</option>
<option>Aadhya 9 Hospital, Shadipur</option>
<option>Apollo Cradle, Moti Nagar</option>
<option>Kailash IVF, Noida</option>

</select>

</div>

</div>


<div className="ips">

<div className="ip">
<label>Select Date</label>

<input
type="date"
min={new Date().toISOString().split("T")[0]}
value={date}
onChange={(e)=>handleDate(e.target.value)}
/>

</div>


<div className="ip">

<label>Available Time</label>

<input type="text" value={time} readOnly/>

</div>

</div>

<br/>

<button onClick={sendWhatsapp}>
Book an appointment
</button>

</div>

</div>

            </div>

        </div>


           {/* <section className="schedule-section">
      <div className="schedule-container">

    
<div className="schedule-left">

  <div className="schedule-row">
    <div className="day">Monday</div>
    <div className="time">
      <div>9 AM - 1 PM</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
        <b>Kailash IVF, Noida</b><br/>
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </div>
      <div>
        <b>Aadhya 9 Hospital, Shadipur</b><br/>
        W-4, Metro Station Shadipur, Gate No. 4, West Patel Nagar, New Delhi - 110008
      </div>
    </div>
  </div>

  <div className="divider"></div>

  <div className="schedule-row">
    <div className="day">Tuesday</div>
    <div className="time">
      <div>9 AM - 1 PM</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
        <b>Kailash IVF, Noida</b><br/>
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </div>
      <div>
        <b>Apollo Cradle, Moti Nagar</b><br/>
        M562+M57, Moti Nagar, Karampura Industrial Area, New Delhi - 110015
      </div>
    </div>
  </div>

  <div className="divider"></div>

  <div className="schedule-row">
    <div className="day">Wednesday</div>
    <div className="time">
      <div>9 AM - 1 PM</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
       <b>Kailash IVF, Noida</b><br/>
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </div>
      <div>
        <b>Aadhya 9 Hospital, Shadipur</b><br/>
        W-4, Metro Station Shadipur, Gate No. 4, West Patel Nagar, New Delhi - 110008
      </div>
    </div>
  </div>

  <div className="divider"></div>

  <div className="schedule-row">
    <div className="day">Thursday</div>
    <div className="time">
      <div>Closed</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
        <b>Kailash IVF, Noida</b><br/>
        (Closed)
      </div>
      <div>
        <b>Aadhya 9 Hospital, Shadipur</b><br/>
        W-4, Metro Station Shadipur, Gate No. 4, West Patel Nagar, New Delhi - 110008
      </div>
    </div>
  </div>

  <div className="divider"></div>

  <div className="schedule-row">
    <div className="day">Friday</div>
    <div className="time">
      <div>9 AM - 1 PM</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
        <b>Kailash IVF, Noida</b><br/>
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </div>
      <div>
        <b>Apollo Cradle, Moti Nagar</b><br/>
        M562+M57, Moti Nagar, Karampura Industrial Area, New Delhi - 110015
      </div>
    </div>
  </div>

  <div className="divider"></div>

  <div className="schedule-row">
    <div className="day">Saturday</div>
    <div className="time">
      <div>9 AM - 1 PM</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
        <b>Kailash IVF, Noida</b><br/>
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </div>
      <div>
        <b>Aadhya 9 Hospital, Shadipur</b><br/>
        W-4, Metro Station Shadipur, Gate No. 4, West Patel Nagar, New Delhi - 110008
      </div>
    </div>
  </div>

  <div className="divider"></div>

  <div className="schedule-row">
    <div className="day">Sunday</div>
    <div className="time">
      <div>9 AM - 1 PM</div>
      <div>5 PM - 7 PM</div>
    </div>
    <div className="place">
      <div>
        <b>Kailash IVF, Noida</b><br/>
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </div>
      <div>
        <b>Aadhya 9 Hospital, Shadipur</b><br/>
        W-4, Metro Station Shadipur, Gate No. 4, West Patel Nagar, New Delhi - 110008
      </div>
    </div>
  </div>

  <div className="divider"></div>

</div>
        
        <div className="schedule-right">
          <img
            src={img}   
            alt="Doctor"
          />
        </div>

      </div>
    </section> */}




<section className="medScheduleSection">
  <div className="medScheduleWrapper">

    {/* LEFT SIDE (CARDS) */}
    <div className="medLeftContent">

      <div className="medCard">
        <h3 className="medTitle">Aadhya 9 Hospital, Shadipur</h3>
        <p className="medAddress">
          W-4, Metro Station Shadipur, Gate No. 4, West Patel Nagar, New Delhi - 110008
        </p>
        <div className="medMeta">
          <span className="medDays">Mon, Wed, Thu, Sat, Sun</span>
          <span className="medTime">5:00 PM – 7:00 PM</span>
        </div>
      </div>

      <div className="medCard">
        <h3 className="medTitle">Apollo Cradle, Moti Nagar</h3>
        <p className="medAddress">
          M562+M57, Moti Nagar, Karampura Industrial Area, New Delhi - 110015
        </p>
        <div className="medMeta">
          <span className="medDays">Tuesday, Friday</span>
          <span className="medTime">5:00 PM – 7:00 PM</span>
        </div>
      </div>

      <div className="medCard highlightCard">
        <h3 className="medTitle">Kailash IVF, Noida</h3>
        <p className="medAddress">
          A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
        </p>
        <div className="medMeta">
          <span className="medDays">Monday – Sunday</span>
          <span className="medTime">9:00 AM – 1:00 PM</span>
        </div>
        <p className="medNote">(Thursday Closed)</p>
      </div>

    </div>

    {/* RIGHT SIDE (IMAGE) */}
    <div className="medRightImage">
      <img src={img} alt="Doctor" />
    </div>

  </div>
</section>




    

    <section className="faq-section">
      <h2 className="faq-title">FAQs</h2>

      <div className="faq-container">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${
              activeIndex === index ? "active" : ""
            }`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFaq(index)}
            >
              <span className="dot">•</span>
              <h4>{item.question}</h4>
              <span className="icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>

            <div
              className={`faq-answer ${
                activeIndex === index ? "show" : ""
              }`}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>

<Footer/>



    </>
  )
}

export default Contact
